import React from 'react';
import CourseProgressWidget from './dashboard/CourseProgressWidget';
import CommunityActivityWidget from './dashboard/CommunityActivityWidget';
import AISuggestionsWidget from './dashboard/AISuggestionsWidget';
import UpcomingEventsWidget from './dashboard/UpcomingEventsWidget';
import StatsWidget from './dashboard/StatsWidget';
const Dashboard = () => {
  return <div className="space-y-4" data-id="element-928">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-929">
        <div className="col-span-1 md:col-span-2" data-id="element-930">
          <CourseProgressWidget data-id="element-931" />
          <div className="mt-4" data-id="element-932">
            <StatsWidget data-id="element-933" />
          </div>
          <div className="mt-4" data-id="element-934">
            <UpcomingEventsWidget data-id="element-935" />
          </div>
        </div>
        <div className="col-span-1" data-id="element-936">
          <AISuggestionsWidget data-id="element-937" />
        </div>
      </div>
    </div>;
};
export default Dashboard;